export const WIDTH = 2700;
export const HEIGHT = 1250;
